<template>
  <div class="div_serach">
    <div class="search-txt-line fr color-btn1">
      <a-input-search type="primary" placeholder="请输入关键字进行查找" v-model="searchText" enter-button class="color-btn" @keyup.enter="toSearch()" @search="toSearch()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searchText: "",
    };
  },
  inject:['isPage','routeName','reload'],
  watch:{
    route_name:{
      handler(val,oldval){
        if(val!=oldval && val!='apps'){
          this.searchText = '';
          sessionStorage.removeItem('apps_seq');
        }

        if(val==='apps'){
          let seq = sessionStorage.getItem('apps_seq');
          this.searchText = seq;
          console.log(seq);
        }
      },
      deep:true,
      immediate: true,

    },
    searchText:{
      handler(val,oldval){
      if(val!=oldval && !val){
        if(this.route_name === 'apps'){
          
            sessionStorage.removeItem('apps_seq');
            this.reload();
        }else{
          this.$store.dispatch('SearchQ',{key:this.routeName(),property:'keyword',val});
        }
      }
      },
      deep:true,
      immediate: true,
    }

  },
  computed:{
    route_name(){
      // console.log(this.$route.name);
      return this.$route.name;
    }
  },
  methods: {
    toSearch(){
      if(this.searchText){
        if(this.isPage('apps')){
          let key = this.routeName() + '_seq';
          sessionStorage.setItem(key,this.searchText);
          this.reload();
        }else{
          let val = this.searchText;
          this.$store.dispatch('SearchQ',{key:this.routeName(),property:'keyword',val});
        }
      }
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/modules/Search.vue